<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-6">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6">
          <div class="label-input">Section Background</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text color" :hide-details="true" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-section'].color"
                    @change="e => (fields['background-section'].color = e.target.value)"
                  />
                  <v-text-field v-model="fields['background-section'].color" label="Background" :hide-details="true" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top padding" :hide-details="true" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom padding" :hide-details="true" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Container content</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Title card</div>
          <div class="group-item">
            <v-checkbox
              v-model="fields['title-card'].showTitle"
              class="mb-2 mt-0"
              label="Show title block"
              :hide-details="true"
            />
            <ckeditor :editor="editor" v-model="fields['title-card'].html" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input-sub">Main item image</div>
          <div class="group-item">
            <UploadImage
              @callback="payload => (fields.rightCardImage = (payload && payload.imageSrc) || '')"
              :image="{ imageSrc: fields.mainItemImage }"
              :height="'160'"
              :typeUpload="'image'"
              @callbackDelete="() => (fields.mainItemImage = '')"
            />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 0">Surround items</label>
            <v-btn :disabled="fields.listItem.length >= 6" small color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span class="line-clamp-1">Item {{ index + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-6">
                  <UploadImage
                    @callback="payload => handleUploadItemImage(index, payload)"
                    :image="{ imageSrc: item.image }"
                    :height="'160'"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveItemImage(index)"
                  />
                </div>
                <div>
                  <label class="label-input mt-2">Text</label>
                  <v-text-field v-model="item.text" placeholder="Text item" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'CardVitalSurroundSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Vital Surround',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        'title-card': {
          showTitle: true,
          html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
        },
        mainItemImage:
          'https://simplynootropics.com/cdn/shop/files/collagen-unflauvoured_db271a14-6bb9-4510-910c-4d73eb8a3a52.png?v=1734516599&width=2077',
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };

    if (!this.fields['title-card']) {
      this.fields['title-card'] = {
        showTitle: true,
        html: '<h2 style="text-align: center;">Lorem ipsum dolor, sit</h2>',
      };
    }

    if (!this.fields.listItem) this.fields.listItem = [];
  },
  methods: {
    handleAddItem() {
      this.fields.listItem.push({
        image: '',
        text: '',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadItemImage(index, payload) {
      if (payload?.imageSrc != null) {
        this.$set(this.fields.listItem[index], 'image', payload.imageSrc);
      }
    },
    handleRemoveItemImage(index) {
      this.$set(this.fields.listItem[index], 'image', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardVitalSurround(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-input-sub {
  font-size: 16px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.ck-editor__editable_inline {
  min-height: 120px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
